import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';
import DomainDetailsLayout from 'components/standard/DomainDetailsLayout';

const Domains = lazy(() => import('containers/pages/domains/Domains'));

const Ssls = lazy(() => import('containers/pages/domains/Ssls'));

const DnsDetails = lazy(
	() => import('containers/pages/domains/details/DnsDetails'),
);

const RegistrationDetails = lazy(
	() => import('containers/pages/domains/details/RegistrationDetails'),
);

const SslDetails = lazy(
	() => import('containers/pages/domains/details/SslDetails'),
);

const ReverseDns = lazy(() => import('containers/pages/domains/ReverseDns'));

const Cloudflare = lazy(() => import('containers/pages/domains/Cloudflare'));

const CloudflareDetails = lazy(
	() => import('containers/pages/domains/Cloudflare/Details'),
);
const NotFound = lazy(() => import('pages/error/NotFound'));

const DomainsRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/domain"
				component={Domains}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/dns"
				component={() => <Redirect to="domain" />}
				whitelistedRoles={[roles.PURCHASER]}
			/>
			{/* legacy route */}
			<RoleRestrictedRoute
				exact
				path="/domain/create-transfer"
				component={() => (
					<Redirect
						to={{
							pathname: '/domain',
							search: '?transfer=true',
						}}
					/>
				)}
			/>
			<RoleRestrictedRoute
				path="/domain/dashboard/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/registration/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl"
				component={Ssls}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl/dashboard/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}/ssl`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			{/* TODO - RDX-278 Cody needs to design a page / dialog that allows you to create a DNS outside the context of a DREG  This route should redirect there */}
			{/* <RoleRestrictedRoute
				path="/domain/dns/add"
				component={CreateDNSZone}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/> */}
			<RoleRestrictedRoute
				path="/domain/ssl/add"
				component={() => (
					<Redirect to={{ pathname: '/domain/ssl', search: '?add=true' }} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/dns/reverse-dns/:uniqId?"
				component={ReverseDns}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>

			<RoleRestrictedRoute
				path="/domain/dns/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}/dns`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/cloudflare"
				component={Cloudflare}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/cloudflare/:uniqId"
				component={CloudflareDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route path="/domain/:domain">
				<DomainDetailsLayout>
					<Switch>
						<RoleRestrictedRoute
							path="/domain/:domain/dns"
							component={DnsDetails}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>

						<RoleRestrictedRoute
							path="/domain/:domain/ssl"
							component={SslDetails}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>

						<RoleRestrictedRoute
							path="/domain/:domain"
							component={RegistrationDetails}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>
					</Switch>
				</DomainDetailsLayout>
			</Route>

			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default DomainsRouter;
